import { Navigate } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import hasRegularAccess from 'modules/employees/lib/hasRegularAccess'
import { useSurveyShowContext } from 'modules/surveys/pages/Show/hooks'

const ShowSurveyFormDefaultPageContainer = () => {
  const { navigation } = useNavigation()
  const { employee: currentEmployee } = useCurrentSession()
  const { canEditSurvey } = useSurveyShowContext()
  const { id } = useStrictParams<'id'>()

  const hasWelcomeSpaceAccess =
    !!currentEmployee && !hasRegularAccess(currentEmployee.hasRegularAccess)

  if (hasWelcomeSpaceAccess) {
    return <NotFound />
  }

  // TODO: need to check the correct flow in the WriteSurveyResponsePage
  // when user can't edit we are redirecting to the survey list
  // but in the AnswerPage -> SurveyAnswer we show a button to go back to responses
  const responsesPath = navigation.engagement.surveys.id.responses.fullPath({ id })
  const configurationPath = navigation.engagement.surveys.id.configuration.fullPath({ id })
  return <Navigate to={canEditSurvey ? configurationPath : responsesPath} />
}

export default ShowSurveyFormDefaultPageContainer
